<template>
  <div class="ac-carousel">
    <slot></slot>
  </div>
</template>

<script>
//import OtherComponent from './OtherComponent.vue'
import { tns } from "tiny-slider/src/tiny-slider";
//import "tiny-slider/dist/tiny-slider.css";

export default {
  name: "carousel",
  props: {
    autoplay: {
      required: false,
      default: true,
      type: [Boolean, String]
    },
    wraparound: {
      required: false,
      default: true,
      type: [Boolean, String]
    },
    items: {
      required: false,
      default: 1,
      type: [Number, String]
    }
  },
  mounted() {
    tns({
      container: this.$el,
      items: this.items,
      autoplay: this.autoplay,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      navPosition: "bottom",
      rewind: true,
      controlsText: [
        '<span class="icon-arrow-left"></span>',
        '<span class="icon-arrow-right"></span>',
      ],
    });
  }
};
</script>

<style lang="scss">

</style>
